// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vueCustomElement from 'vue-custom-element'

// Import jQuery first and make it global
import $ from 'jquery'
window.jQuery = window.$ = $

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
// import 'jquery/dist/jquery.min.js'
import '../public/style.css'
import 'document-register-element/build/document-register-element'
import PaymentPage from "@/views/PaymentPage.vue";

Vue.config.productionTip = false
Vue.use(vueCustomElement)
App.store = store
App.router = router
Vue.customElement('gattinoni-payment', PaymentPage)

// REMOVE THIS PART:
// new Vue({
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app')